(() => {
  let scheduled = false;
  const updateRatings = () => {
    document.querySelectorAll('[data-floris-native-rating]').forEach((root) => {
      const source = root.querySelector('.lipscore-rating-small[data-ls-product-rating]');
      const countSource = root.querySelector('.lipscore-review-count[data-ls-product-review-count]');
      const button = root.querySelector('[data-floris-rating-button]');
      if (!source || !countSource || !button) return;
      const rating = Number(source.getAttribute('data-ls-product-rating')) / 2;
      const count = countSource.getAttribute('data-ls-product-review-count');
      if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !/^\d+$/.test(count)) {
        button.hidden = true;
        return;
      }
      const value = String(Math.round(rating * 10) / 10);
      root.querySelectorAll('[data-floris-rating-value]').forEach((node) => {
        if (node.textContent !== value) node.textContent = value;
      });
      root.querySelectorAll('[data-floris-review-count]').forEach((node) => {
        if (node.textContent !== count) node.textContent = count;
      });
      button.setAttribute('aria-label', `${value} / 5, ${count} ${root.dataset.reviewLabel}`);
      const stars = root.querySelector('[data-floris-rating-stars]');
      if (stars) stars.setAttribute('aria-label', value + ' / 5');
      const fraction = rating % 1;
      const decimal = fraction >= 0.3 && fraction <= 0.7 ? 0.5 : fraction > 0.7 ? 1 : 0;
      const full = Math.floor(rating);
      root.querySelectorAll('.rating > svg.stars').forEach((star, index) => {
        const filled = root.dataset.ratingStyle === 'single' || index < full + Math.ceil(decimal);
        star.classList.toggle('filled-star', filled);
        const fill = star.querySelector('use');
        if (decimal === 0.5 && index === full) fill?.setAttribute('fill', 'url(#half)');
        else fill?.removeAttribute('fill');
      });
      root.querySelectorAll('.rating-star').forEach((star) => {
        star.style.setProperty('--rating', String(full));
        star.style.setProperty('--rating-max', '5');
        star.style.setProperty('--rating-decimal', String(decimal));
      });
      button.hidden = false;
    });
  };
  const initialise = () => {
    scheduled = false;
    if (window.lipscore?.isInitialized()) window.lipscore.initWidgets();
    updateRatings();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(initialise);
  };
  const widgets = '.lipscore-rating-small, .lipscore-review-count, #lipscore-rating, .lipscore-review-list';
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.type === 'attributes')) updateRatings();
    if (mutations.some((mutation) => mutation.type === 'childList' && [...mutation.addedNodes].some((node) =>
      node instanceof Element && (node.matches(widgets) || node.querySelector(widgets))
    ))) schedule();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-ls-product-review-count', 'data-ls-product-rating']
  });
  document.addEventListener('lipscore-created', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule, { once: true });
  schedule();
})();
